// Registra el service worker solo en producción (en desarrollo interfiere con el hot reload).
// Requiere HTTPS (o localhost) para funcionar.
export const registrarServiceWorker = () => {
  if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/service-worker.js`)
      .catch((error) => console.error("Error registrando el service worker:", error));
  });
};
